import React from 'react';
import illustration from '../Assets/ILLUSTRATION.png';
import play from '../Assets/Group 117.png';

export default function Main() {
    return (
        <>
            <div className="Main">
                <div className="left">
                    <span className="span">Claim a Free Quote</span>
                    <h1><span>Get started</span> on fulfilling <br /> your Dubai or UAE <br /> dream.</h1>
                    <span className="span">UAE & OffShore Company</span>
                    <p>We provide you with information about UAE or <br />
                        OffShore Company Registration & help you <br />
                        setup your company with a bank account and <br />
                        visa.</p>
                    <button id="leftbtn">Start a Company</button>
                    <button id="rightbtn">Renew a Company</button>
                </div>

                <div className="right">
                    <img src={illustration} alt="/" />
                </div>
            </div>
            <div className="below">
                <h2>Watch the video about UAE or Offshore Company Registration</h2>
                <img src={play} alt="/"></img>
            </div>
        </>
    );
}
